<div class="p-4 border-bottom border-1 overflow-hidden faq">
  <div class="d-flex justify-content-between position-relative">
    <div class="d-flex gap-5">
      <span>({{index+1 | number: '2.0-0'}})</span>
      <span>{{ question }}</span>
    </div>

    <img src="/assets/img/faq-open-btn.svg" class="open-button" (click)="changeState()"
      [ngStyle]="isOpen ? btnOpenedStyle : btnClosedStyle">
    <img src="/assets/img/faq-close-btn.svg" class="close-button" (click)="changeState()"
      [ngStyle]="isOpen ? closeBtnOpenedStyle : closeBtnClosedStyle">
  </div>

  <p class="p-5" [ngStyle]="isOpen ? openedStyle : closedStyle" #faqText [innerHTML]="answer"></p>
</div>